import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {Overlay} from '../../services/overlay/Overlay';
import {Subject} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';
import {animateShow} from '../../animations/showHideAnimation';
import {OverlayService} from '../../services/overlay/overlay.service';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-overlay-tab-item',
  templateUrl: './overlay-tab-item.component.html',
  styleUrls: ['./overlay-tab-item.component.scss'],
  animations: [animateShow],
})
export class OverlayTabItemComponent implements OnInit {
  @Input() item: Overlay;
  @Input() isEventOwner = false;
  @Input() defaultVisibleItem: {id: number; opacity: number};
  @Input() isActive: boolean;
  @Output() isVisibleChange = new EventEmitter<
    {id: number; isVisible: boolean} | undefined
  >();
  @Output() opacityChanged = new EventEmitter<number>();
  @Output() deleteOverlayWith = new EventEmitter<Overlay>();
  @Output() itemClicked = new EventEmitter<Overlay>();
  @Output() renameOverlay = new EventEmitter<{
    overlay: Overlay;
    newName: string;
  }>();

  @ViewChild('renameInput', {static: false}) renameInput: ElementRef;
  public renameControl: FormControl;
  public opacity$ = new Subject<number>();
  public canUseControls: boolean = false;
  private isVisible = false;
  get visibility() {
    return this.isVisible;
  }

  constructor(private cd: ChangeDetectorRef, private os: OverlayService) {}

  getItemOpacityForRange() {
    return this.item.opacity * 100;
  }

  ngOnInit() {
    this.canUseControls = window['CAN_SELF_IMPORT_CAD'];
    this.os.overlayTabs[this.item.id] = this;
    this.item.isVisible = false;
    this.item.hide();

    this.opacity$.pipe(debounceTime(500)).subscribe(opacityNumber => {
      const resultOpacity = opacityNumber / 100;
      this.item.setOpacity(resultOpacity);
      this.opacityChanged.emit(resultOpacity);
      this.cd.detectChanges();
    });

    this.os.changedInVisibleOverlays$
      .pipe(filter(config => config.hasOwnProperty(this.item.getId())))
      .subscribe(config => {
        if (config.hasOwnProperty(this.item.getId())) {
          this.isVisible = config[this.item.getId()];
          this.cd.detectChanges();
        }
      });

    if (
      this.defaultVisibleItem &&
      this.defaultVisibleItem.id === this.item.getId()
    ) {
      this.isVisible = true;
      this.item.isVisible = true;
      this.item.setOpacity(this.defaultVisibleItem.opacity);
    } else {
      this.isVisible = false;
      this.item.isVisible = false;
    }

    this.renameControl = new FormControl(this.item.name, {updateOn: 'blur'});

    this.cd.detectChanges();
  }

  toggleItemVisibility() {
    if (
      this.os.hasUnsavedLayoutChanges() &&
      !confirm(
        'You have not saved the changes made to the overlay. Proceed anyway?'
      )
    ) {
      return;
    }

    this.isVisible = !this.isVisible;
    this.isVisibleChange.emit({
      id: this.item.getId(),
      isVisible: this.isVisible,
    });
    this.item.isVisible = this.isVisible;
    if (this.isVisible) {
      this.item.show();
      this.os.addToVisibleLayouts(this.item);
    } else {
      this.item.hide();
      this.os.removeFromVisibleLayouts(this.item);
    }
    this.cd.detectChanges();
  }

  onItemClicked(event: PointerEvent): void {
    const isIgnored = ['es-eye-icon'].some((toIgnore: string) =>
      (event.target as HTMLElement).className.includes(toIgnore)
    );

    if (isIgnored) {
      return;
    }

    this.itemClicked.emit(this.item);
  }

  showRename(): void {
    this.renameInput.nativeElement.focus();
  }

  public rename(): void {
    const newName = this.renameControl.value;
    if (!newName) {
      return;
    }

    this.renameOverlay.emit({overlay: this.item, newName});
  }
}
